import React, { useEffect, useRef, useState } from 'react';
import { updateCartCount } from '../../../helpers';
import { useSelector } from 'react-redux';

const Fireworks = ({ itemAdded }) => {
    const fireworksInstance = useRef(null); // To hold the FireworksOverlay instance
    const [cartCount, setCartCount] = useState(0);
    const totalRewards = useSelector((state) => state.auth.totalRewards);

    useEffect(() => {
        // Initial count load
        // Listen for the custom 'cartUpdated' event
        updateCartCount(setCartCount);
        window.addEventListener('cartUpdated', () => {
            updateCartCount(setCartCount);
        });

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('cartUpdated', () => {
                updateCartCount(setCartCount);
            });
        };
    }, []);

    useEffect(() => {
        let script;
        let timeout;
        if (
            (itemAdded && cartCount === 1) ||
            (totalRewards === 0 && cartCount === 1)
        ) {
            // Dynamically load the script
            script = document.createElement('script');
            script.src =
                'https://dadevmikey.github.io/The-Holiday-Library/NewYearsOverlay.js';
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
                if (window.FireworksOverlay) {
                    fireworksInstance.current = new window.FireworksOverlay({
                        colors: ['#FF0000', '#00FF00', '#0000FF'],
                        particleCount: 100,
                        interval: 500
                    });
                    fireworksInstance.current.startAnimation();

                    timeout = setTimeout(() => {
                        if (fireworksInstance.current) {
                            fireworksInstance.current.stopAnimation &&
                                fireworksInstance.current.stopAnimation();
                            fireworksInstance.current = null;
                        }
                    }, 2000);
                } else {
                    console.error('FireworksOverlay is not defined');
                }
            };
        } else {
            // Stop animation and clean up if itemAdded is false
            if (fireworksInstance.current) {
                fireworksInstance.current.stopAnimation &&
                    fireworksInstance.current.stopAnimation();
                fireworksInstance.current = null;
            }
        }

        return () => {
            // Cleanup on unmount
            if (fireworksInstance.current) {
                fireworksInstance.current.stopAnimation &&
                    fireworksInstance.current.stopAnimation();
                fireworksInstance.current = null;
            }
            if (script) {
                document.body.removeChild(script);
            }
            clearTimeout(timeout); // Ensure timeout is cleared on unmount
        };
    }, [itemAdded, totalRewards, cartCount]); // Re-run the effect when itemAdded changes

    return null; // This component doesn't render anything visually
};

export default Fireworks;
